import Vue from 'vue'
import Vuex from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import api from '@/backendapi'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /**
     * Used to prevent accidental navigation away from page.
     *
     * See App.vue for the event handler that uses this.
     */
    uiVersion: process.env.APP_VERSION || '0',
    apiVersion: '1.0.0',
    leaveGuard: false,
    user: {},
    userList: [],
    categoryOptions: [{ value: null, text: 'Categories loading...', disabled: true }],
    ingestFields: {
      "mathematics": [],
      "material": [],
      "vto": [],
      "sgh": [],
      "ocp": []
    }
  },
  mutations: {
    setLeaveGuard(state, enable) {
      state.leaveGuard = enable
    },
    setUser(state, payload) {
      /**
       * Payload is expected to be a decoded JWT object.
       */
      let user = {
        username: payload.sub,
        role: payload.role,
        tokenExpiry: payload.exp, // Timestamp
      }
      state.user = user
    },
    setUserList(state, payload) {
      state.userList = payload
    },
    setApiVersion(state, versionStr) {
      state.apiVersion = versionStr
    },
    setCategoryOptions(state, categoryOptions) {
      state.categoryOptions = categoryOptions
    },
    setIngestFieldsList(state, payload){
      let fieldType = payload.type
      let fieldDefinitions = payload.fields
      state.ingestFields[fieldType] = fieldDefinitions
    },
    setOCPFieldsList(state, ocpFieldsList) {
      state.ocpFieldsList = ocpFieldsList
    },
    setSGHFieldsList(state, sghFieldsList) {
      state.sghFieldsList = sghFieldsList
    },
    setComplexityTimeOffsetsList(state, complexityTimeOffsetsList) {
      state.complexityTimeOffsetsList = complexityTimeOffsetsList
    },
  },
  actions: {
    async login(store, payload) {
      //let payload = { username: username, password: password };
      try {
        const res = await api.postLogin(payload)
        let token = res.access_token
        localStorage.setItem('token', token)
        let tokenData = VueJwtDecode.decode(token)
        store.commit('setUser', tokenData)
        store.dispatch('getApiVersion')
        store.dispatch('getCategories')
      } catch (err) {
        throw err.response
      }
    },
    async logout(store) {
      localStorage.removeItem('token')
      store.dispatch('logoutClearState')
    },
    /**
     * Clear all Vuex state that could be populated from user action.
     *
     * @param {*} state
     */
    logoutClearState(store) {
      store.commit('setUser', {})
      store.commit('setUserList', [])
      let options = [{ value: null, text: 'Select a category', disabled: true }]
      store.commit('setCategoryOptions', options)
    },
    async getUsers(store) {
      try {
        const res = await api.getUsers(localStorage.token)
        store.commit('setUserList', res)
        return res
      } catch (err) {
        throw err.response
      }
    },
    // TODO: Would be better as "createUser"
    async createUser(store, payload) {
      //let payload = { email, password, role };
      try {
        return await api.postCreateUser(localStorage.token, payload)
      } catch (err) {
        throw err.response
      }
    },
    async changePassword(store, payload) {
      //let payload = { username, password };
      try {
        return api.putChangePassword(localStorage.token, payload, store.state.user.username)
      } catch (err) {
        throw err.response
      }
    },
    async modifyUser(store, payload) {
      //let payload = { email, password, role };
      let processed_payload = {role: payload.role}
      if (('new_password' in payload)) {
          processed_payload.new_password = payload.new_password
      }
      try {
        return api.putModifyUser(localStorage.token, processed_payload, payload.email)
      } catch (err) {
        throw err.response
      }
    },
    async deleteUser(store, userEmail) {
      try {
        return api.deleteUser(localStorage.token, userEmail)
      } catch (err) {
        throw err.response
      }
    },
    async printProfile() {
      try {
        const res = await api.getProfile(localStorage.token)
        return res
      } catch (err) {
        throw err.response
      }
    },
    async getApiVersion(store) {
      api.getApiVersion(localStorage.token).then((version) => {
        store.commit('setApiVersion', version)
      })
    },
    async getCategories(store) {
      let categories = await api.getCategories(localStorage.token)
      let options = [{ value: null, text: 'Select an ingest type', disabled: true }]
      for (let cat of categories) {
        options.push(cat)
      }
      store.commit('setCategoryOptions', options)
    },
    async getIngestFields(store, fieldType) {
      try {
        const res = await api.getIngestFields(localStorage.token, fieldType)
        store.commit('setIngestFieldsList', {type: fieldType, fields: res})
      } catch (err) {
        throw err.response
      }
    },
    async createFieldMapping(store, payload) {
      try {
        const res = await api.postCreateFieldMapping(localStorage.token, payload)
        return res
      } catch (err) {
        throw err.response
      }
    },
    async deleteFieldMapping(store, payload) {
      try {
        const res = await api.deleteFieldMapping(localStorage.token, payload)
        return res
      } catch (err) {
        throw err.response
      }
    },
  },
  modules: {},
})
